import { ExternalLink } from 'lucide-react';

/**
 * Says a third-party flow went to the system browser and where it comes back (ADR-160 AC-18,
 * I-1078). Shown only in the desktop app, after `leaveForThirdParty` answered `browser`: the page
 * was never replaced, so without it the screen would look as if the click did nothing.
 *
 * Blue, like the other "nothing is wrong, here is what happens next" notes, and never the red of a
 * refusal.
 */
export function ContinueInBrowserNotice({
  title,
  detail,
  dismissLabel,
  onDismiss,
  testId,
}: {
  title: string;
  detail: string;
  dismissLabel: string;
  onDismiss: () => void;
  testId: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={testId}
      className="rounded-md border border-blue-200 bg-blue-50 px-3 py-2.5 text-[13px] text-blue-900 dark:border-blue-900/40 dark:bg-blue-950/30 dark:text-blue-100"
    >
      <div className="flex items-start gap-2.5">
        <ExternalLink className="mt-px h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="min-w-0">
          <span className="font-medium">{title}</span>
          <span className="mt-0.5 block">{detail}</span>
        </span>
      </div>
      <div className="mt-1.5 pl-[26px]">
        <button
          type="button"
          onClick={onDismiss}
          className="rounded-sm font-medium evx-link focus:outline-none focus-visible:ring-2 focus-visible:ring-focus"
        >
          {dismissLabel}
        </button>
      </div>
    </div>
  );
}
